module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/propose-restaurant-og-image-290c5d9026a3c26479a553f1a1d89eac.jpg";